enum researcherType {
    student = 1, //นิสิต / นักศึกษา	Student
    lecturer = 2, //อาจารย์	Lecturer
    researcher = 3, //นักวิจัย	Researcher
}
export default researcherType
